import { rowClassRules } from "../utils/classRules"
import FullScreenGrid from "../Portfolio/components/FullScreenGrid"
import { Column, Mask, Row, ScrollPosition } from "../types"
import { RowStyleProtocol } from "./agGridMapping"
import { ColumnSizingStrategy, IContextMenuItemDef, useAgGrid } from "./hooks/useAgGrid"

export interface IGridProps {
  /**
   * Rows and columns to be displayed in ag-grid
   */
  rows: Row[]
  columns: Column[]
  /**
   * Label to be displayed on top of the grid container
   * Info to be displayed on top right of the grid container
   * through FullScreen Children
   */
  label?: string
  children?: React.ReactNode
  contextMenuItemsDef?: IContextMenuItemDef[]
  rowStyles?: RowStyleProtocol[]
  initialScrollPosition?: ScrollPosition
  columnSizingStrategy?: ColumnSizingStrategy
  masks?: Record<string, Mask[]>
}

const Grid = ({
  rows,
  columns,
  label,
  children,
  contextMenuItemsDef,
  rowStyles,
  initialScrollPosition,
  columnSizingStrategy,
}: IGridProps) => {
  const { gridRef, gridOptions } = useAgGrid({
    columns,
    contextMenuItemsDef,
    rowStyles,
    initialScrollPosition,
    columnSizingStrategy,
  })

  return (
    <FullScreenGrid
      label={label}
      ref={gridRef}
      rowClassRules={rowClassRules}
      rowData={rows}
      suppressHorizontalScroll={false}
      rowHeight={25}
      suppressCellFocus={true}
      {...gridOptions}
    >
      {children}
    </FullScreenGrid>
  )
}

export default Grid
